import React, { useState, useEffect, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "@mui/material/Pagination";
import axiosInstance from "../../../../components/axiosInstance";
import { API_URLS } from "../../../../apiUrl";
import CustomSelect from "../../../../components/CustomSelect";

interface Municipality {
  id: number;
  name: string;
  primary_id: any;
  municipality_name: any;
}

interface Borough {
  id: number;
  name: string;
  municipality_id: number;
  borough_primary_id: any;
  borough_name: any;
}

interface Ward {
  id: number;
  name: string;
  borough_id: number;
  ward_primary_id: any;
  ward_no: string;
}

interface Collector {
  primary_id: any;
  admin_name: string;
  collector_id?: string;
  login_user_name?: string;
}

interface DepositEntry {
  id: any;
  collector_id: number;
  amount: string;
  remarks: string;
  deposited_date: string;
  deposited_by: number;
  collector_name: string;
  collector_email: string | null;
  collector_street: string | null;
  collector_username: string | null
  ward_no: string;
}

interface DashboardSummary {
  total_amount: any;
  total_collectors: any;

  daily_amount: any;
  total_deposited_in_last_3_months: any;
  total_deposited_in_current_fy: any;
  total_deposited_in_last_fy: any;
  daily_deposited_collectors: any;
}

const ITEMS_PER_PAGE = 10;

// ✅ FIX 1: useAnimatedCount moved to top level (Rules of Hooks)
const useAnimatedCount = (target: number, duration = 1200) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (target === 0) { setCount(0); return; }
    let start = 0;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  return count;
};


const AnimatedCards = ({ data }: { data: DashboardSummary | null }) => {

  const dailyAmount = Number(data?.daily_amount ?? 0);
  const last3Months = Number(data?.total_deposited_in_last_3_months ?? 0);
  const currentFY = Number(data?.total_deposited_in_current_fy ?? 0);
  const dailyCollectors = Number(data?.daily_deposited_collectors ?? 0);

  const animDailyAmount = useAnimatedCount(dailyAmount);
  const animLast3Months = useAnimatedCount(last3Months);
  const animCurrentFY = useAnimatedCount(currentFY);
  const animCollectors = useAnimatedCount(dailyCollectors);

  return (
    <div className="grid grid-cols-10 gap-6 mb-8 items-stretch">

      {/* Today Deposit */}
      <div className="col-span-3 bg-white shadow-md rounded-lg p-5 flex flex-col">
        <p className="text-gray-500 text-sm font-semibold text-center border-b pb-2">
          Today Deposit
        </p>

        <div className="flex flex-1 items-center justify-center">
          <p className="text-2xl font-bold text-green-600">
            ₹ {animDailyAmount.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Middle Card */}
      <div className="col-span-4 bg-white shadow-md rounded-lg p-5 flex items-center">
        <div className="grid grid-cols-3 divide-x w-full text-center">

          <div className="flex flex-col justify-center">
            <p className="text-gray-500 text-sm font-semibold">
              Last Day
            </p>
            <p className="text-xl font-bold text-green-600 mt-2">
              ₹ {animDailyAmount.toLocaleString()}
            </p>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-gray-500 text-sm font-semibold">
              Last 3 Month
            </p>
            <p className="text-xl font-bold text-purple-600 mt-2">
              ₹ {animLast3Months.toLocaleString()}
            </p>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-gray-500 text-sm font-semibold">
              FY
            </p>
            <p className="text-xl font-bold text-blue-600 mt-2">
              ₹ {animCurrentFY.toLocaleString()}
            </p>
          </div>

        </div>
      </div>

      {/* Daily Collectors */}
      <div className="col-span-3 bg-white shadow-md rounded-lg p-5 flex flex-col">
        <p className="text-gray-500 text-sm font-semibold text-center border-b pb-2">
          Daily Deposited Collectors
        </p>

        <div className="flex flex-1 items-center justify-center">
          <p className="text-2xl font-bold text-red-600">
            {animCollectors.toLocaleString()}
          </p>
        </div>
      </div>

    </div>
  );
};

const Accountant = () => {
  const Name = localStorage.getItem("user_name");
  const Municipality_id = localStorage.getItem('municipality_id_v2');
  // const Municipality_name = localStorage.getItem('municipality_name_v2');

  const [view, setView] = useState<"list" | "form">("list");

  const [depositList, setDepositList] = useState<DepositEntry[]>([]);
  const [listPage, setListPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingList, setLoadingList] = useState(false);

  const [municipalities, setMunicipalities] = useState<Municipality[]>([]);
  const [boroughs, setBoroughs] = useState<Borough[]>([]);
  const [wards, setWards] = useState<Ward[]>([]);
  const [collectors, setCollectors] = useState<Collector[]>([]);

const [selectedMunicipality, setSelectedMunicipality] = useState<string>(
  String(Municipality_id || "")
);  const [selectedBorough, setSelectedBorough] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [selectedCollector, setSelectedCollector] = useState("");
  const [depositDate, setDepositDate] = useState(new Date().toISOString().split("T")[0]);
  const [depositedAmount, setDepositedAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [submitting, setSubmitting] = useState(false);
const [dashboardSummary, setDashboardSummary] = useState<DashboardSummary>({
  total_amount: 0,
  total_collectors: 0,
  daily_amount: 0,
  total_deposited_in_last_3_months: 0,
  total_deposited_in_current_fy: 0,
  total_deposited_in_last_fy: 0,
  daily_deposited_collectors: 0,
});


  const formRef = useRef<HTMLDivElement | null>(null);
  const today = new Date().toISOString().split("T")[0];


const fetchDepositList = async (page: number) => {
  setLoadingList(true);
  try {
    const res = await axiosInstance.post(API_URLS.collectordepostlisting, {
      page,
      limit: ITEMS_PER_PAGE,
    });

    const rows = res.data?.data?.data ?? [];                        
    const lastPage = res.data?.data?.pagination?.lastPage ?? 1;    

    setDepositList(rows);
    setTotalPages(lastPage);
  } catch (err: any) {
    const msg = err?.response?.data?.message || err?.message || "Failed to load deposit list";
    toast.error(msg);
  } finally {
    setLoadingList(false);
  }
};

 const fetchDashboardSummary = () => {
  axiosInstance
    .post(API_URLS.cashierdeposit)
    .then((res) => {
      const response = res.data?.data;
      setDashboardSummary(response);
    })
    .catch((err) => {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load Cashier Summary";
      toast.error(msg);
    });
};

useEffect(() => {
  fetchDashboardSummary();
}, []);

useEffect(() => {
  fetchDepositList(listPage);
}, [listPage]); 


  useEffect(() => {
    axiosInstance
      .post(API_URLS.MunicipalityList, { page: 1, limit: 50 })
      .then((res) => {
        const raw = res.data?.data;
        const list = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? [];
        setMunicipalities(list);
      })
      .catch((err: any) => {
        const msg = err?.response?.data?.message || err?.message || "Failed to load municipalities";
        toast.error(msg);
      });
  }, []);

  useEffect(() => {
    if (!selectedMunicipality) {
      setBoroughs([]);
      setSelectedBorough("");
      return;
    }
    axiosInstance
      .post(API_URLS.GetMunicipalityBorough, {
        municipalityTbl_id: Number(selectedMunicipality),
        page: 1,
        limit: 50,
        surveyer_id: 0,
      })
      .then((res) => {
        const raw = res.data?.data;
        const list = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? [];
        setBoroughs(list);
        setSelectedBorough("");
        setWards([]);
        setSelectedWard("");
        setCollectors([]);
        setSelectedCollector("");
      })
      .catch((err: any) =>
        toast.error(err?.response?.data?.message || err?.message || "Failed to load boroughs")
      );
  }, [selectedMunicipality]);

  useEffect(() => {
    if (!selectedBorough) {
      setWards([]);
      setSelectedWard("");
      return;
    }
    axiosInstance
      .post(API_URLS.GetBoroughWiseWard, {
        borough_primary_id: selectedBorough,
        municipalityTbl_id: selectedMunicipality,
        page: 1,
        limit: 50,
        surveyer_id: 0,
      })
      .then((res) => {
        const raw = res.data?.data;
        const list = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? [];
        setWards(list);
        setSelectedWard("");
        setCollectors([]);
        setSelectedCollector("");
      })
      .catch((err: any) =>
        toast.error(err?.response?.data?.message || err?.message || "Failed to load wards")
      );
  }, [selectedBorough]);

  const fetchBoroughs = async (municipalityId: string) => {
  try {
    const res = await axiosInstance.post(API_URLS.GetMunicipalityBorough, {
      municipalityTbl_id: Number(municipalityId),
      page: 1,
      limit: 50,
      surveyer_id: 0,
    });

    const raw = res.data?.data;
    const list = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? [];
    setBoroughs(list);
  } catch (err: any) {
    toast.error(
      err?.response?.data?.message || err?.message || "Failed to load boroughs"
    );
  }
};

  useEffect(() => {
    if (!selectedWard) {
      setCollectors([]);
      setSelectedCollector("");
      return;
    }
    axiosInstance
      .post(API_URLS.usercashier, { role_name: "collector", ward_id: Number(selectedWard) })
      .then((res) => {
        const raw = res.data?.data;
        const list = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? [];
        setCollectors(list);
        setSelectedCollector("");
      })
      .catch((err: any) =>
        toast.error(err?.response?.data?.message || err?.message || "Failed to load collectors")
      );
  }, [selectedWard]);

const resetForm = () => {

  setSelectedBorough("");
  setSelectedWard("");
  setSelectedCollector("");

  setDepositDate(new Date().toISOString().split("T")[0]);
  setDepositedAmount("");
  setRemarks("");

  setWards([]);
  setCollectors([]);

  if (selectedMunicipality) {
    fetchBoroughs(selectedMunicipality);
  }

};
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedMunicipality) { toast.error("Please select a Municipality"); return; }
    if (!selectedBorough) { toast.error("Please select a Borough"); return; }
    if (!selectedWard) { toast.error("Please select a Ward"); return; }
    if (!selectedCollector) { toast.error("Please select a Collector"); return; }
    if (!depositDate) { toast.error("Deposit date is required"); return; }
    if (depositDate > today) { toast.error("Future date is not allowed"); return; }
    const amount = Number(depositedAmount);
    if (isNaN(amount) || amount <= 0) { toast.error("Deposited amount must be greater than 0"); return; }
    if (remarks.trim().length > 250) { toast.error("Remarks must be under 250 characters"); return; }

    setSubmitting(true);
    try {
      await axiosInstance.post(API_URLS.despost, {
        ward_id: String(selectedWard),
        collector_id: String(selectedCollector),
        amount,
        remarks: remarks.trim(),
        deposited_date: depositDate,
      });
      toast.success(`₹${amount.toLocaleString()} deposited successfully`, { autoClose: 2000 });
      resetForm();
      setView("list");
      fetchDepositList(1);
      setListPage(1);
      fetchDashboardSummary();
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Something went wrong.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };




  const selectClass =
    "w-full border border-gray-300 rounded-md px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-sm disabled:bg-gray-100 disabled:cursor-not-allowed";

const [remarksPopup, setRemarksPopup] = useState<string | null>(null);
  const truncateRemarks = (text: string, wordLimit = 15) => {
  if (!text) return "";

  const words = text.split(" ");
  if (words.length <= wordLimit) return text;

  return words.slice(0, wordLimit).join(" ") + "...";
};

useEffect(()=>{
setSelectedMunicipality(String(Municipality_id))
},[])

useEffect(() => {
  if (!selectedMunicipality) {
    setBoroughs([]);
    setSelectedBorough("");
    return;
  }

  fetchBoroughs(selectedMunicipality);

  setSelectedBorough("");
  setWards([]);
  setSelectedWard("");
  setCollectors([]);
  setSelectedCollector("");

}, [selectedMunicipality]);

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <ToastContainer position="top-right" />

      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold mb-6">Accountant / Cashier — {Name}</h1>
        {view === "list" && (
          <button
      onClick={() => {
  setView("form");

  if (selectedMunicipality) {
    fetchBoroughs(selectedMunicipality);
  }

  setTimeout(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  }, 100);
}}
            className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-lg font-semibold hover:bg-blue-700 transition text-sm"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Deposit
          </button>
        )}
      </div>

      <AnimatedCards data={dashboardSummary} />

      {view === "list" && (
  <div className="bg-white shadow-md rounded-lg border">
  <div className="overflow-x-auto">
    <table className="min-w-full table-auto">
      <thead className="bg-gray-100 border-b">
        <tr>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">#</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Collector</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Username</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Email</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Ward</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Deposited Date</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Amount (₹)</th>
          <th className="py-3 px-5 text-left text-sm font-semibold text-gray-600">Remarks</th>
        </tr>
      </thead>
      <tbody>
        {loadingList ? (
          <tr>
            <td colSpan={7} className="py-16 text-center">
              <div className="flex flex-col items-center gap-3">
                <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                <p className="text-sm text-gray-400">Loading deposits...</p>
              </div>
            </td>
          </tr>
        ) : depositList.length === 0 ? (
          <tr>
            <td colSpan={7} className="py-16 text-center text-gray-400">
              No deposit entries found
            </td>
          </tr>
        ) : (
          depositList.map((item, idx) => (
            <tr key={item.id} className="border-b hover:bg-gray-50 transition">
              <td className="py-3 px-5 text-sm text-gray-500">
                {(listPage - 1) * ITEMS_PER_PAGE + idx + 1}
              </td>
              <td className="py-3 px-5 text-sm font-medium text-gray-800">{item.collector_name}</td>
              <td className="py-3 px-5 text-sm text-gray-600">{item.collector_username || "—"}</td>

              <td className="py-3 px-5 text-sm text-gray-600">{item.collector_email || "—"}</td>
              <td className="py-3 px-5 text-sm text-gray-600">{item.ward_no || "—"}</td>
              <td className="py-3 px-5 text-sm text-gray-600">{new Date(item.deposited_date).toLocaleDateString("en-IN")}</td>
              <td className="py-3 px-5 text-sm font-semibold text-green-700">₹{Number(item.amount).toLocaleString()}</td>
              <td className="py-3 px-5 text-sm text-gray-500">
                {item.remarks ? (
                  item.remarks.split(" ").length > 15 ? (
                    <div className="flex items-center gap-2">
                      <span>{truncateRemarks(item.remarks)}</span>
                      <button onClick={() => setRemarksPopup(item.remarks)} className="text-blue-600 hover:text-blue-800">
                        <i className="ri-information-fill text-lg"></i>
                      </button>
                    </div>
                  ) : (
                    item.remarks
                  )
                ) : "—"}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>

    {totalPages > 1 && (
      <div className="flex justify-center py-4 border-t">
        <Pagination
          count={totalPages}
          page={listPage}
          onChange={(_, value) => setListPage(value)}
          color="primary"
        />
      </div>
    )}
  </div>
</div>
      )}



      {remarksPopup && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    
    <div className="bg-white rounded-lg shadow-lg w-[400px] max-w-[90%] p-6 relative">
      
      <h2 className="text-lg font-semibold mb-3">Remarks</h2>

      <p className="text-gray-600 text-sm leading-relaxed">
        {remarksPopup}
      </p>

      <button
        onClick={() => setRemarksPopup(null)}
        className="absolute top-3 right-3 text-gray-400 hover:text-red-500"
      >
        <i className="ri-close-line text-xl"></i>
      </button>

    </div>

  </div>
)}

      {view === "form" && (
        <div ref={formRef} className="bg-white shadow-md rounded-lg p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Deposit Date <span className="text-red-500">*</span>
              </label>
              <input
                type="date"
                value={depositDate}
                onChange={(e) => setDepositDate(e.target.value)}
                max={today}
                className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
             

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Borough <span className="text-red-500">*</span>
                </label>
        

<CustomSelect
  value={selectedBorough}
  onChange={(e:any)=>setSelectedBorough(e.target.value)}
  options={boroughs.map((c) => ({
    value: String(c.borough_primary_id),
    label: c.borough_name,
  }))}
/>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Ward <span className="text-red-500">*</span>
                </label>
         

   <CustomSelect
  name=""
  value={selectedWard}
  onChange={(e:any)=>setSelectedWard(e.target.value)}
  options={wards.map((w) => ({
    value: w.ward_primary_id,
    label: w.ward_no,
  }))}
  disabled={!selectedBorough}
/>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Collector <span className="text-red-500">*</span>
                </label>
           

                <CustomSelect
                name=""
  value={selectedCollector}
 onChange={(e:any)=>setSelectedCollector(e.target.value)}
   options={collectors.map((c) => ({
    value: String(c.primary_id),
    label: `${c.admin_name} (${c.login_user_name})`,
  }))}
  disabled={!selectedWard}
/>
                {selectedWard && collectors.length === 0 && (
                  <p className="text-orange-500 text-xs mt-1">No collectors found for this ward</p>
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Deposited Amount (₹) <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                value={depositedAmount}
                onChange={(e) => setDepositedAmount(e.target.value)}
                minLength={1}
                maxLength={7}
                placeholder="Enter amount"
                className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Remarks <span className="text-gray-400 text-xs">(Optional, max 250 characters)</span>
              </label>
              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                maxLength={250}
                rows={3}
                placeholder="Any notes or reference..."
                className="w-full border border-gray-300 rounded-md px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
              <p className="text-xs text-gray-400 text-right mt-1">{remarks.length}/250</p>
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => {
                  resetForm();
                  setView("list");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="px-6 py-3 rounded-lg font-semibold bg-red-600 text-white hover:bg-red-700 transition"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={submitting}
                className="flex-1 bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition"
              >
                {submitting ? "Saving..." : "Save Deposit"}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default Accountant;